import { useScreenSize } from 'src/customHooks/customHooks'
import CoolMultiCardCarousel from '../common/CoolMultiCardCarousel/CoolMultiCardCarousel'
import {
  FourStepRecoveryPlanContainer,
  FourStepRecoveryPlanLevelContainer,
  FourStepRecoveryPlanLevelItem,
} from './styledComponents'

export default function FourStepRecoveryPlan() {
  const mainHeading = 'STEP'
  const { width, height } = useScreenSize()
  const breakPoint = 768

  const cardsData = [
    {
      headingIcon: <CardNumber mainHeading={mainHeading} number={1} />,
      heading: 'Self-Discovery',
      subHeading: 'Understanding Addiction at Your Own Pace',
      description:
        'Begin by understanding addiction and its impact on your life. This level allows you to learn at your own pace, with resources tailored to increase awareness and understanding of addiction.',
      styles: width >= breakPoint ? { height: '70%' } : null,
    },
    {
      headingIcon: <CardNumber mainHeading={mainHeading} number={2} />,
      heading: 'Empowerment',
      subHeading: 'Building Resilience with Guided Support',
      description:
        'Empower yourself with coping skills and strategies to manage cravings and triggers. This level provides guided support from professionals, including Cognitive Behavioral Therapy (CBT) and stress management techniques, to help you build resilience and confidence.',
      styles: width >= breakPoint ? { height: '80%' } : null,
    },
    {
      headingIcon: <CardNumber mainHeading={mainHeading} number={3} />,
      heading: 'Transformation',
      subHeading: 'Healing with Intensive Therapeutic Care',
      description:
        'Experience transformative healing with intensive therapeutic care. This level involves deep exploration of underlying issues, individual and family therapy, and medication management under the guidance of experienced professionals.',
      styles: width >= breakPoint ? { height: '90%' } : null,
    },
    {
      headingIcon: <CardNumber mainHeading={mainHeading} number={4} />,
      heading: 'Liberation',
      subHeading: 'Thriving with Continued Professional Support',
      description:
        'Achieve liberation from addiction and thrive in your recovery with continued professional support. This level focuses on relapse prevention, aftercare planning, and ongoing monitoring and support to help you maintain long-term recovery and well-being.',
      styles: width >= breakPoint ? { height: '100%' } : null,
    },
  ]

  return (
    <CoolMultiCardCarousel
      carouselHeading="Behavioral De-Addiction"
      carouselSubHeading="A Four-Step Recovery Plan"
      cards={cardsData}
      cardsContainerStyles={{ alignItems: 'flex-end' }}
      MainContainerStyledComponent={FourStepRecoveryPlanContainer}
    />
  )
}

function CardNumber({ number, mainHeading }) {
  return (
    <FourStepRecoveryPlanLevelContainer>
      <h6 className="icon-heading">{mainHeading}</h6>
      <FourStepRecoveryPlanLevelItem>{number}</FourStepRecoveryPlanLevelItem>
    </FourStepRecoveryPlanLevelContainer>
  )
}
